// WS-75: screen-space dither (TSL). Interleaved gradient noise (Jimenez 2014): one value per pixel, evenly spread, so
// two complementary tests on the same value (a < k, a >= k) draw every pixel exactly once (the dithered hand-overs).
import { float, vec2, fract, dot, screenCoordinate } from 'three/tsl';

/** IGN of a pixel position (vec2 node, pixels). */
export const ign = (p) => fract(float(52.9829189).mul(fract(dot(p, vec2(0.06711056, 0.00583715)))));
/** IGN of the current fragment (WebGPU's pixel origin is top-left, WebGL's bottom-left: the pattern differs, its spread does not). */
export const ignFrag = () => ign(screenCoordinate.xy);
